import styled from 'styled-components';

export const CardContainer = styled.div`
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1.25em;
  padding-top: 1.75em;
  gap: 0.75em;
  overflow: visible;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.button.default};

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${({ theme }) => theme.shadows.button.hover};
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
      width: 48px;
      height: 48px;
    }
  }

  .label {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.8px;
    text-align: center;
    color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  }
`;
